import { stripeCustomerPortal } from "@/graphql/queries";

export const billing = {
    data () {
        return {
            billingIsSubmitting: false
        }
    },
    methods: {
        async openBillingPortal() {

            if (this.billingIsSubmitting) {
                return
            }

            this.billingIsSubmitting = true;
            this.$root.$emit('loading', true);

            try {

                let baseUrl = process.env.VUE_APP_BASE_URL;

                const stripeUrlObject = await this.$apollo.query({
                    query: stripeCustomerPortal,
                    variables: {
                        input: {
                            projectId: this.currentProject.id,
                            returnUrl: `${baseUrl}/return/stripe/${this.currentProject.id}`
                        }
                    }
                });
                
                console.log(stripeUrlObject)

                const stripeUrl = stripeUrlObject.data.stripeCustomerPortal.customerPortalUrl

                window.location.href = stripeUrl;

            } catch (e) {
                console.log(e)
            }


            this.billingIsSubmitting = false;
            this.$root.$emit('loading', false);
        }
    }
};
  